import { useLoaderData as useLoaderDataBase } from "@remix-run/react";
import type { LoaderData } from "./LoaderData";
import deserializeCompany from "~/company/helpers/deserializeCompany";
import deserializeImage from "~/kernel/image/deserializeImage";

export default function useLoaderData(): LoaderData {
  const loaderData = useLoaderDataBase<LoaderData>();

  return {
    ...loaderData,
    popularCompanies: loaderData.popularCompanies.map((company) => {
      return {
        ...company,
        ...deserializeCompany(company),
        banner: company.banner ? deserializeImage(company.banner) : null,
      };
    }),
  };
}
